module.exports = __webpack_public_path__ + "static/EWY_Rebecca_social-cover-2f5407bb236f77e8cdc7248364871ca9.png";